import React, { useEffect, useState } from 'react';
import { supabase } from '../supabase';

// Vídeos próprios do INEP (sem YouTube): bucket PRIVADO "inep-videos" no Storage
// (docs/sql/2026-10-12-inep-videos-bucket.sql). A aula guarda a referência
// "sb://inep-videos/<caminho>"; para assistir, o player pede um link temporário.

const BUCKET = 'inep-videos';
const PREFIXO = `sb://${BUCKET}/`;
const URL_SB = process.env.REACT_APP_SUPABASE_URL;
const ANON = process.env.REACT_APP_SUPABASE_ANON_KEY;
export const LIMITE_VIDEO_MB = 500;

const nomeSeguro = n => String(n || 'video').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-zA-Z0-9._-]+/g, '_').slice(-80);

// Envia o arquivo mostrando o progresso (0–100). Retorna a referência sb://...
export async function enviarVideo(file, onProgresso) {
  if (file.size > LIMITE_VIDEO_MB * 1024 * 1024) throw new Error(`O vídeo tem ${(file.size / 1048576).toFixed(0)} MB — o máximo é ${LIMITE_VIDEO_MB} MB. Comprima antes de enviar.`);
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Sessão expirada — entre de novo.');
  const caminho = `cursos/${Date.now()}-${Math.random().toString(36).slice(2, 7)}-${nomeSeguro(file.name)}`;
  await new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${URL_SB}/storage/v1/object/${BUCKET}/${caminho}`);
    xhr.setRequestHeader('Authorization', `Bearer ${session.access_token}`);
    xhr.setRequestHeader('apikey', ANON);
    xhr.setRequestHeader('Content-Type', file.type || 'video/mp4');
    xhr.setRequestHeader('x-upsert', 'false');
    xhr.upload.onprogress = e => { if (e.lengthComputable) onProgresso?.(Math.round(e.loaded / e.total * 100)); };
    xhr.onload = () => (xhr.status >= 200 && xhr.status < 300
      ? resolve()
      : reject(new Error(`Falha no envio (${xhr.status}): ${(xhr.responseText || '').slice(0, 200)}`)));
    xhr.onerror = () => reject(new Error('Falha de rede durante o envio.'));
    xhr.send(file);
  });
  return PREFIXO + caminho;
}

// Duração (minutos, arredondado para cima) lida do próprio arquivo, antes de enviar
export function duracaoDoArquivo(file) {
  return new Promise(resolve => {
    const v = document.createElement('video');
    v.preload = 'metadata';
    v.onloadedmetadata = () => { URL.revokeObjectURL(v.src); resolve(Number.isFinite(v.duration) ? Math.max(1, Math.ceil(v.duration / 60)) : null); };
    v.onerror = () => resolve(null);
    v.src = URL.createObjectURL(file);
  });
}

const cacheLinks = {};
async function linkTemporario(ref) {
  const c = cacheLinks[ref];
  if (c && c.expira > Date.now() + 5 * 60 * 1000) return c.url;
  const caminho = ref.slice(PREFIXO.length);
  const { data, error } = await supabase.storage.from(BUCKET).createSignedUrl(caminho, 4 * 3600);
  if (error || !data?.signedUrl) throw new Error(error?.message || 'Vídeo indisponível');
  const url = /^https?:/.test(data.signedUrl) ? data.signedUrl : `${URL_SB}/storage/v1${data.signedUrl}`;
  cacheLinks[ref] = { url, expira: Date.now() + 4 * 3600 * 1000 };
  return url;
}

export const ehVideoProprio = ref => typeof ref === 'string' && ref.startsWith(PREFIXO);

// Player do vídeo próprio. onTerminou: chamado quando o vídeo chega ao fim.
export function VideoProprio({ refVideo, titulo, onTerminou }) {
  const [url, setUrl] = useState('');
  const [erro, setErro] = useState('');
  useEffect(() => {
    let vivo = true;
    setUrl(''); setErro('');
    linkTemporario(refVideo).then(u => { if (vivo) setUrl(u); }).catch(e => { if (vivo) setErro(e.message); });
    return () => { vivo = false; };
  }, [refVideo]);
  if (erro) return <div className="inep-video-empty"><b>Não foi possível carregar o vídeo</b><small>{erro}</small></div>;
  if (!url) return <div className="inep-video-empty"><div className="inep-play">▶</div><b>Carregando vídeo…</b></div>;
  return (
    <video key={url} src={url} title={titulo} controls controlsList="nodownload" preload="metadata" playsInline
      onContextMenu={e => e.preventDefault()} onEnded={onTerminou}
      style={{ width: '100%', height: '100%', background: '#000', borderRadius: 'inherit' }} />
  );
}
